module.exports = __webpack_public_path__ + "img/sound_wave.0b956031.gif";